import { useMutation } from "@tanstack/react-query";
import ApiClient from "../../../api/ApiClient";
import { AxiosError } from "axios";

async function deleteCategory(categoryId: number | undefined): Promise<void> {
    try {
        if (!categoryId) throw new Error("Category ID is required");
        await ApiClient({ url: `categories/${categoryId}`, method: "DELETE" });
    } catch (error) {
        throw new Error(error instanceof AxiosError ? error.response?.data?.error : "An unexpected error occurred");
    }
}

export function useDeleteCategoryMutation(onSuccess: () => void, onError: (error: Error) => void) {
    return useMutation<void, Error, number | undefined>({
        mutationKey: ["delete-category"],
        mutationFn: deleteCategory,
        onSuccess,
        onError
    });
}